import Request from './request'

const DeviceConfiguration = {
  getDeviceConfigJson (id, callback) {
    Request.get('device-configuration/ui-json/' + id).then(callback).catch(this.bad_answer)
  },
  getDeviceConfig (fid, callback) {
    Request.get('device-configuration/get-config/' + fid).then(callback).catch(this.bad_answer)
  },
  saveDeviceConfig (fid, params, callback, bad_answer) {
    Request.post('device-configuration/save-config/' + fid, JSON.stringify(params)).then(callback).catch(bad_answer)
  },
  saveUIDeviceConfig (fid, params, callback) {
    Request.post('device-configuration/save-ui-config/' + fid, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  resetDeviceConfigVersion (fid, callback) {
    Request.post('device-configuration/reset-ver-config/' + fid).then(callback).catch(this.bad_answer)
  },
  getConfigByVersion (fid, params, callback){
    Request.post('device-configuration/get-config-by-version/' + fid, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getConfigDocumentation (callback){
    Request.get('device-configuration/get-config-documentation').then(callback).catch(this.bad_answer)
  },
  getSimAPN (fid, callback){
    Request.get('device-configuration/simcards-apn/' + fid).then(callback).catch(this.bad_answer)
  },
  compareConfigs (dev_id, params, callback){
    Request.get('device-configuration/different/' + dev_id, params).then(callback).catch(this.bad_answer)
  },
  updateDeviceAddress(id, params, callback){
    Request.post('device-configuration/update-device-addresses/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  removeDeviceAddress(id, callback){
    Request.get('device-configuration/remove-device-addresses/' + id).then(callback).catch(this.bad_answer)
  },
  findDeviceAddress(id, callback){
    Request.get('device-configuration/find-device-addresses/' + id).then(callback).catch(this.bad_answer)
  },
  getAvailableDeviceConfigs(fid, callback){
    Request.get('device-configuration/get-available-configs/' + fid).then(callback).catch(this.bad_answer)
  },
}
export default DeviceConfiguration
